var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header border-bottom"},[_c('router-link',{staticClass:"px-4 border-right",attrs:{"to":"/"}},[_c('img',{staticClass:"icon",attrs:{"src":"/slogin.png"}})]),_vm._t("default",[_c('h5',[_vm._v(_vm._s(_vm.title))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }